import { UPGRADE_BASE_URL } from '@zapier/design-system-revenue/src/constants';
import { isBrowser } from '@zapier/design-system-revenue/src/utils';

export const isOnUpgradeRoute = () => {
  if (!isBrowser()) {
    return false;
  }

  return window.location.pathname.includes(UPGRADE_BASE_URL);
};
